import EditorConfigContext, { EditorConfigProvider, useEditorConfig } from './context'

export function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item)
}

export function merge(target, ...sources) {
    if (!sources.length) return target
    const source = sources.shift()

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} })
                merge(target[key], source[key])
            } else {
                Object.assign(target, { [key]: source[key] })
            }
        }
    }

    return merge(target, ...sources)
}

class Config {
    constructor(plugins, config) {
        let defaultPluginConfig = plugins.content
            .map(plugin => {
                let config = {}

                if (plugin.hasOwnProperty('configKey')) {
                    config[plugin.configKey] = plugin.config
                }

                return config
            })
            .reduce((carry, componentConfig) => Object.assign(carry, componentConfig), {})

        this.config = merge({}, { plugin: defaultPluginConfig }, config)
    }

    all() {
        return this.config
    }

    get(propertyPath, def = null) {
        return (
            propertyPath.split('.').reduce((prev, curr) => {
                return prev ? prev[curr] : undefined
            }, this.config) || def
        )
    }
}

export default Config

export { EditorConfigContext, EditorConfigProvider, useEditorConfig }
